import { render, staticRenderFns } from "./MerchantFeeConfigAddNew.vue?vue&type=template&id=5085e736&"
import script from "./MerchantFeeConfigAddNew.vue?vue&type=script&lang=js&"
export * from "./MerchantFeeConfigAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports